import type { FormFieldOption, ProcessedFormField } from "@/types/api/formSchema";

export function optionDisplayName(
  field: ProcessedFormField | undefined,
  raw: unknown,
): string | null {
  if (!field) return null;
  const source = (field.list ?? field.options ?? field.fields) as
    | (string | FormFieldOption)[]
    | undefined;
  if (!Array.isArray(source)) return null;
  for (const opt of source) {
    if (typeof opt === "string") {
      if (opt === raw) return opt;
    } else if ((opt as FormFieldOption).name === raw) {
      return (opt as FormFieldOption).display_name ?? String(raw);
    }
  }
  return null;
}

export function formatValue(
  field: ProcessedFormField,
  raw: unknown,
): string | null {
  if (raw == null || raw === "") {
    if (field.type === "boolean") return "No";
    return null;
  }
  if (field.type === "boolean") return raw ? "Yes" : "No";
  if (
    field.type === "phone" &&
    typeof raw === "object" &&
    !Array.isArray(raw)
  ) {
    const p = raw as { number?: string; country_code?: string };
    if (!p.number) return null;
    return `${p.country_code ?? ""} ${p.number}`.trim();
  }
  if (Array.isArray(raw)) {
    const items = raw
      .map((v) => formatValue(field, v))
      .filter((s): s is string => s != null);
    return items.length ? items.join(", ") : null;
  }
  if (
    field.type === "select" ||
    field.type === "radio" ||
    field.type === "checkbox"
  ) {
    return optionDisplayName(field, raw) ?? String(raw);
  }
  if (field.type === "number" && typeof raw !== "object") {
    const n = Number(raw);
    // Default: plain Indian-grouped number ("15,00,000") with no currency
    // symbol. Adding "₹" here would falsely tag counters like credit_days
    // or MSME-registration IDs as currency. Consumers that need currency
    // formatting (e.g. Review & Submit's `expected_business_volume`) can
    // wrap the display value at the call site.
    if (!Number.isNaN(n)) return n.toLocaleString("en-IN");
  }
  if (typeof raw === "object") return JSON.stringify(raw);
  return String(raw);
}
